<template>
  <div class="modal fade" ref="CmpModalFiltrosListadoClientes" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1" role="dialog"  aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered modal-xl" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">
            Filtros
          </h5>
          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="modal"
            aria-label="Close"
          ></button>
        </div>
        <div class="modal-body">
          <p>
            Da click sobre el switch deseado para realizar el filtrado:
          </p>
          
          <div class="row">
            <div class="col-lg-3 col-md-6">
              <div class="form-check form-switch form-switch-lg mb-3" dir="ltr">
                <input 
                  v-model="filtros.activos"
                  @change="filtrosActualizados()"
                  class="form-check-input"
                  type="checkbox"
                  id="activos"
                />
                <label class="form-check-label" for="activos">Activos</label>
              </div>
            </div>
            <div class="col-lg-3 col-md-6">
              <div class="form-check form-switch form-switch-lg mb-3" dir="ltr">
                <input 
                  v-model="filtros.retirados"
                  @change="filtrosActualizados()"
                  class="form-check-input"
                  type="checkbox"
                  id="retirados"
                />
                <label class="form-check-label" for="retirados">Retirados</label>
              </div>
            </div>
            <div class="col-lg-3 col-md-6">
              <div class="form-check form-switch form-switch-lg mb-3" dir="ltr">
                <input
                  v-model="filtros.suspendidos"
                  @change="filtrosActualizados()"
                  class="form-check-input"
                  type="checkbox"
                  id="suspendidos"
                  :disabled="!filtros.activos"
                />
                <label class="form-check-label" for="suspendidos">Suspendidos</label>
              </div>
            </div>
            <div class="col-lg-3 col-md-6">
              <div class="form-check form-switch form-switch-lg mb-3" dir="ltr">
                <input
                  v-model="filtros.atrasados"
                  @change="filtrosActualizados()"
                  class="form-check-input"
                  type="checkbox"
                  id="atrasados"
                  :disabled="!filtros.activos"
                />
                <label class="form-check-label" for="atrasados">Atrasados</label>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-lg-3 col-md-6">
              <div class="form-check form-switch form-switch-lg mb-3" dir="ltr">
                <input
                  v-model="filtros.recien_registrados"
                  @change="filtrosActualizados()"
                  class="form-check-input"
                  type="checkbox"
                  id="recienRegistrados"
                  :disabled="!filtros.activos"
                />
                <label class="form-check-label" for="recienRegistrados">Recién registrados</label>
              </div>
            </div>
            <div class="col-lg-3 col-md-6">
              <div class="form-check form-switch form-switch-lg mb-3" dir="ltr">
                <input
                  v-model="filtros.con_facturas_sin_pagar"
                  @change="filtrosActualizados()"
                  class="form-check-input"
                  type="checkbox"
                  id="swConFacturasSinPagar"
                  :disabled="!filtros.activos"
                />
                <label class="form-check-label" for="swConFacturasSinPagar">Con facturas sin pagar</label>
              </div>
            </div>

            <div class="col-lg-3 col-md-6 col-6" v-show="filtros.con_facturas_sin_pagar">
              <div class="input-group">
                <span class="input-group-text">Desde </span>
                <input type="number" v-model="filtros.facturas_sin_pagar_desde"
                  min="1"
                  class="form-control"
                  oninput="this.value = Math.abs(this.value)"
                  @change="filtrosActualizados()"
                />
              </div>
            </div>

            <div class="col-lg-3 col-md-6 col-6" v-show="filtros.con_facturas_sin_pagar">
              <div class="input-group">
                <span class="input-group-text">Hasta</span>
                <input type="number" v-model="filtros.facturas_sin_pagar_hasta"
                  min="1"
                  placeholder="- - -"
                  class="form-control"
                  @change="
                    facturasSinPagarHasta(),
                    filtrosActualizados()
                  "
                />
              </div>
            </div>
            <div class="col-lg-3 col-md-6">
              <div class="form-check form-switch form-switch-lg mb-3" dir="ltr">
                <input
                  v-model="filtros.renta_mensual_fija"
                  @change="filtrosActualizados()"
                  class="form-check-input"
                  type="checkbox"
                  id="rentaMensualFija"
                  :disabled="!filtros.activos"
                />
                <label class="form-check-label" for="rentaMensualFija">
                  Renta mensual fija
                </label>
              </div>
            </div>

            <div class="col-lg-3 col-md-6">
              <div class="form-check form-switch form-switch-lg mb-3" dir="ltr">
                <input
                  v-model="filtros.renta_mensual_variable"
                  @change="filtrosActualizados()"
                  class="form-check-input"
                  type="checkbox"
                  id="rentaMensualVariable"
                  :disabled="!filtros.activos"
                />
                <label class="form-check-label" for="rentaMensualVariable">
                  Renta mensual variable
                </label>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-lg-3 col-md-6">
              <div class="form-check form-switch form-switch-lg mb-3" dir="ltr">
                <input 
                  v-model="filtros.sin_contratos"
                  @change="filtrosActualizados()"
                  class="form-check-input"
                  type="checkbox"
                  id="contratos"
                  :disabled="!filtros.activos"
                />
                <label class="form-check-label" for="contratos">Sin contratos</label>
              </div>
            </div>
            <div class="col-lg-3 col-md-6">
              <div class="form-check form-switch form-switch-lg mb-3" dir="ltr">
                <input 
                  v-model="filtros.control_manual"
                  @change="filtrosActualizados()"
                  class="form-check-input"
                  type="checkbox"
                  id="controlManual"
                  :disabled="!filtros.activos"
                />
                <label class="form-check-label" for="controlManual">Control manual</label>
              </div>
            </div>
            <div class="col-lg-3 col-md-6">
              <div class="form-check form-switch form-switch-lg mb-3" dir="ltr">
                <input 
                  v-model="filtros.control_automatico"
                  @change="filtrosActualizados()"
                  class="form-check-input"
                  type="checkbox"
                  id="controlAutomatico"
                  :disabled="!filtros.activos"
                />
                <label class="form-check-label" for="controlAutomatico">Control automatico</label>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-lg-3 col-md-6">
              <div class="form-check form-switch form-switch-lg mb-3" dir="ltr">
                <input 
                  v-model="filtros.con_fecha_corte"
                  @change="filtrosActualizados()"
                  class="form-check-input"
                  type="checkbox"
                  id="conFechaCorte"
                  :disabled="!filtros.activos"
                />
                <label class="form-check-label" for="conFechaCorte">
                  Fecha de corte
                </label>
              </div>
            </div>

            <div class="col-lg-3 col-md-6 col-6" v-show="filtros.con_fecha_corte">
              <div class="input-group">
                <span class="input-group-text">
                  <i class="mdi mdi-calendar-today me-1"></i>
                  Inicio
                </span>
                <input 
                  type="date" class="form-control"
                  v-model="filtros.fecha_inicial_corte"
                  @change="filtrosActualizados()"
                />
              </div>
            </div>

            <div class="col-lg-3 col-md-6 col-6" v-show="filtros.con_fecha_corte">
              <div class="input-group">
                <span class="input-group-text">
                  <i class="mdi mdi-calendar-today me-1"></i>
                  Fin
                </span>
                <input 
                  type="date" class="form-control"
                  v-model="filtros.fecha_final_corte"
                  @change="filtrosActualizados()"
                />
              </div>
            </div>
          </div>
          
          <hr class="mt-1 mb-1">

          <div class="mt-3">
            <h5 class="mb-1">Etiquetas</h5>
            <p class="text-muted small mb-3">
              Selecciona una o más etiquetas para filtrar los clientes que las tengan asignadas.
            </p>

            <div class="d-flex flex-wrap gap-2">
              <label 
                v-for="etiqueta in etiquetas" 
                :key="etiqueta.id"
                class="etiqueta-chip"
                :class="{ activa: etiqueta.activa }"
                :title="etiqueta.nombre"
              >
                <input
                  type="checkbox"
                  class="d-none"
                  :checked="etiqueta.activa"
                  @change="
                    etiqueta.activa = !etiqueta.activa,
                    actualizarIdsEtiquetas()
                  "
                />
                <span 
                  class="color-circle"
                  :style="{ backgroundColor: etiqueta.color }"
                ></span>
                <span class="nombre">
                  {{ etiqueta.nombre }}
                </span>
              </label>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button
            type="button"
            class="btn btn-light"
            data-bs-dismiss="modal"
          >
            Cerrar
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import EtiquetaClientesSrv from '@/services/EtiquetaClientesSrv';
import Modal from 'bootstrap/js/dist/modal';
export default {
  name: 'CmpModalFiltrosListadoClientes',
  props: ['idsEtiquetas', 'valoresInicialesFiltros'],
  data() {
    return {
      filtros: {
        activos: true,
        suspendidos: false,
        atrasados: false,
        retirados: false,
        recien_registrados: false,
        nuevosAMasAntiguos:false,
        con_facturas_sin_pagar:false,
        facturas_sin_pagar_desde: 1,
        facturas_sin_pagar_hasta: null,
        renta_mensual_fija: false,
        renta_mensual_variable: false,
        sin_contratos: false,
        control_manual: false,
        control_automatico: false,


        con_fecha_corte: false,
        fecha_inicial_corte: '',
        fecha_final_corte: ''
      },

      etiquetas: []
    }
  },

  watch: {
    'filtros.activos': function(newVar, oldVar){
      var self = this
      if(newVar == true){
        self.filtros.suspendidos = false
        self.filtros.atrasados = false
        self.filtros.retirados = false
        self.filtros.recien_registrados = false
        self.filtros.nuevosAMasAntiguos = false
        self.filtros.con_facturas_sin_pagar = false
        self.filtros.facturas_sin_pagar_desde = 1
        self.filtros.facturas_sin_pagar_hasta = null
        self.filtros.renta_mensual_fija = false
        self.filtros.renta_mensual_variable = false
        self.filtros.sin_contratos = false
        self.filtros.control_manual = false
        self.filtros.control_automatico = false
        self.filtros.con_fecha_corte = false
        self.filtros.fecha_inicial_corte = ''
        self.filtros.fecha_final_corte = ''
      }
    },
    'filtros.control_manual': function(newVar) {
      var self = this

      if (newVar == false) return

      self.filtros.control_automatico = false
    },

    'filtros.control_automatico': function(newVar) {
      var self = this

      if (newVar == false) return

      self.filtros.control_manual = false
    },

    idsEtiquetas: {
      deep: true,
      handler() {
        this.sincronizarEtiquetasActivas()
      }
    }
  },

  created: function() {
    var self = this
    // Actualización de los valores iniciales de los filtros
    if (self.valoresInicialesFiltros) {
      self.filtros = self.valoresInicialesFiltros
    }
  },

  methods: {
    facturasSinPagarHasta() {
      var self = this

      if(self.filtros.facturas_sin_pagar_hasta == null || self.filtros.facturas_sin_pagar_hasta == '') return

      if(self.filtros.facturas_sin_pagar_desde > self.filtros.facturas_sin_pagar_hasta)
        self.filtros.facturas_sin_pagar_hasta = self.filtros.facturas_sin_pagar_desde
    },

    filtrosActualizados() {
      this.$emit('filtros-actualizados', this.filtros)
    },

    mostrar() {
      var self = this
      self.cargarEtiquetas()
      const modal = new Modal(this.$refs.CmpModalFiltrosListadoClientes)
      modal.show()
    },

    actualizarIdsEtiquetas: function() {
      var self = this
      let idsEtiquetas = self.etiquetas.filter(e => {
        return e.activa == true
      })

      idsEtiquetas = idsEtiquetas.map(e => e.id)

      self.$emit("actualizar:ids:etiquetas", idsEtiquetas)
    },

    cargarEtiquetas: function() {
      var self = this,
        params = {
          dato: self.dato,
          sin_usar: true
        }

      EtiquetaClientesSrv.etiquetasJSON(params).then(response => {
        let etiquetas = response.data

        etiquetas.map(function(etiqueta) {
          etiqueta.activa = false
          return etiqueta
        })

        self.etiquetas = etiquetas
        self.sincronizarEtiquetasActivas()
      }).catch(error => {
        let mensaje = error?.response?.data?.message || 'No se cargaron las etiquetas'
        iu.msg.error(mensaje)
        console.error(error)
      })
    },

    sincronizarEtiquetasActivas() {
      let self = this

      // Normalizar ids
      let ids = self.idsEtiquetas
      ids = Array.isArray(ids) ? ids : (ids ? [ids] : [])

      // Convertir a número por seguridad
      ids = ids.map(id => Number(id))

      self.etiquetas.forEach(etiqueta => {
        etiqueta.activa = ids.includes(Number(etiqueta.id))
      })
    }
  },
}
</script>

<style scoped>
.etiqueta-chip {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 2px 5px;
  border-radius: 20px;
  background-color: #f1f3f5;
  cursor: pointer;
  transition: all 0.2s ease;
  max-width: 220px;
  border: 1px solid transparent;
}

.etiqueta-chip:hover {
  background-color: #e9ecef;
}

.etiqueta-chip.activa {
  background-color: #e6f4ea;
  border-color: #63AD6F;
}

.etiqueta-chip .nombre {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: 13px;
  max-width: 100px;
}

.color-circle {
  min-width: 14px;
  width: 14px;
  height: 14px;
  border-radius: 50%;
  border: 1px solid rgba(0,0,0,0.1);
}
</style>
